"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _StaggeredScaleIn = _interopRequireDefault(require("../effect/animation/StaggeredScaleIn"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  src/form/Checkbox.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 11/20/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* External Libraries */

/* Lego Components */

/* Lego Toolkit */
var DEFAULT_SIZE = 12;
var DEFAULT_DISABLED = false;
var DEFAULT_CHECKED = false;
var propDoc = {
  size: {
    required: false,
    defaultValue: "".concat(DEFAULT_SIZE),
    type: "number",
    description: "Size of the checkbox"
  },
  checked: {
    required: false,
    defaultValue: "".concat(DEFAULT_CHECKED),
    type: "boolean",
    description: "Whether the checkbox is checked or not"
  },
  onChange: {
    required: false,
    defaultValue: undefined,
    type: "(checked: boolean) => unknown",
    description: "Callback for when the checkbox is clicked"
  },
  disabled: {
    required: false,
    defaultValue: "".concat(DEFAULT_DISABLED),
    type: "boolean",
    description: "Controls whether the checkbox is disabled or not"
  }
};
var demoProps = {
  checked: true
}; // NOTE: "PARTIAL" is treated as false

var checkedAsBoolean = function checkedAsBoolean(checked) {
  if (typeof checked === "boolean") {
    return checked;
  }

  return checked === "ON";
};

var checkedAsCheckboxState = function checkedAsCheckboxState(checked) {
  if (typeof checked !== "boolean") {
    return checked;
  }

  return checked ? "ON" : "OFF";
};

var Checkbox = function Checkbox(props, ref) {
  var _props$checked = props.checked,
      checked = _props$checked === void 0 ? DEFAULT_CHECKED : _props$checked,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? DEFAULT_DISABLED : _props$disabled,
      onChange = props.onChange,
      className = props.className,
      style = props.style;
  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: (0, _styling.css)(className, style, !disabled && "ripple"),
    onClick: function onClick(event) {
      if (!disabled && onChange) {
        onChange(!checkedAsBoolean(checked));
        event.stopPropagation();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_StaggeredScaleIn["default"], {
    className: (0, _styling.css)(styles.root),
    animationDurationMs: 150
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.background)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.checkmarkContainer)
  }, checkedAsCheckboxState(checked) === "PARTIAL" && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.dot)
  }), checkedAsCheckboxState(checked) === "ON" && /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    name: "check",
    className: (0, _styling.css)(styles.checkmark)
  }))));
};

exports.Checkbox = Checkbox;
var exportedComponent = /*#__PURE__*/(0, _react.forwardRef)(Checkbox);
exportedComponent.propDoc = propDoc;
exportedComponent.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(exportedComponent);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? DEFAULT_SIZE : _props$size,
      _props$checked2 = props.checked,
      checked = _props$checked2 === void 0 ? DEFAULT_CHECKED : _props$checked2,
      _props$disabled2 = props.disabled,
      disabled = _props$disabled2 === void 0 ? DEFAULT_DISABLED : _props$disabled2;

  var _useTheme = (0, _providers.useTheme)(),
      checkedColor = _useTheme.primary,
      surfaceLightest = _useTheme.surfaceLightest,
      surfaceDark = _useTheme.surfaceDark,
      textWhite = _useTheme.textWhite;

  var disabledColor = surfaceDark;
  var isChecked = checkedAsCheckboxState(checked) !== "OFF";
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        border: disabled ? "solid 2px ".concat(disabledColor) : "solid 2px ".concat(isChecked ? checkedColor : surfaceDark),
        opacity: disabled ? 0.5 : 1,
        borderRadius: 2,
        backgroundColor: surfaceLightest,
        width: size,
        height: size,
        cursor: disabled ? "default" : "pointer",
        position: "relative",
        flexShrink: 0
      },
      checkmark: {
        color: textWhite
      },
      dot: {
        backgroundColor: textWhite,
        width: 6,
        height: 6,
        borderRadius: "50%"
      },
      background: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: disabled ? disabledColor : checkedColor,
        opacity: disabled ? 0.5 : 1,
        transition: "opacity 0.3s linear",
        display: isChecked || disabled ? "block" : "none"
      },
      checkmarkContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    });
  }, [checkedColor, disabledColor, surfaceLightest, surfaceDark, textWhite, isChecked, disabled, size]);
};